import { query as queryUsers, queryCurrent } from '@/services/user';
import { fetchGrayTest, fetchSameLevelTest, fetchZdcPermissionCheck } from '@/services/api';
import { mcEventWithConfig, mvEventWithConfig, pvEvent } from '@/utils/lxEventUtil';
import { produce } from 'immer';

export default {
  namespace: 'user',

  state: {
    list: [],
    currentUser: {},
    permissionCode: 200,
    abTest: false,
    releaseBeforeAuditAbTest: false,
    qualificationAbTest: false,
    currentCid: null,
    lxGlobalLab: {},
  },

  effects: {
    *pv({ payload }, { call, put, select }) {
      console.log('[lx:pv]', payload);
      let cid = '',
        lab = {};
      if (Array.isArray(payload)) {
        cid = payload[0];
        lab = payload[1] || {};
      } else if (typeof payload === 'string') {
        cid = payload;
      }
      const common = yield select(state => state.user.lxGlobalLab);
      yield put({ type: 'lxPv', payload: payload[0] });
      yield call(pvEvent, {
        cid,
        valLab: {
          ...lab,
          common,
        },
      });
    },
    *mv({ payload }, { call, select }) {
      console.log('[lx:mv]', payload);
      let bid = '',
        lab = {};
      if (Array.isArray(payload)) {
        bid = payload[0];
        lab = payload[1] || {};
      } else if (typeof payload === 'string') {
        bid = payload;
      }
      const common = yield select(state => state.user.lxGlobalLab);
      yield call(mvEventWithConfig, {
        bid,
        valLab: {
          ...lab,
          common,
        },
      });
    },
    *mc({ payload }, { call, select }) {
      console.log('[lx:mc]', payload);
      let bid = '',
        lab = {};
      if (Array.isArray(payload)) {
        bid = payload[0];
        lab = payload[1] || {};
      } else if (typeof payload === 'string') {
        bid = payload;
      }
      const common = yield select(state => state.user.lxGlobalLab);
      yield call(mcEventWithConfig, {
        bid,
        valLab: {
          ...lab,
          common,
        },
      });
    },
    *fetch(_, { call, put }) {
      const response = yield call(queryUsers);
      yield put({
        type: 'save',
        payload: response,
      });
    },
    *fetchCurrent(_, { call, put }) {
      const response = yield call(queryCurrent);
      yield put({
        type: 'saveCurrentUser',
        payload: response,
      });
    },
    *fetchSameLevelTest(_, { call, put }) {
      const response = yield call(fetchSameLevelTest);
      yield put({
        type: 'setSameLevelTest',
        payload: [
          'baseinfoMergeTest',
          response?.strategyHitName === 'gray-release-poi-samelevel-one',
        ],
      });
    },
    *fetchGrayTest(_, { call, put }) {
      const response1 = yield call(fetchGrayTest);
      const response2 = yield call(fetchGrayTest, 'sales_pc_publish_before_audit');
      yield put({
        type: 'setGrayTest',
        payload: ['abTest', response1],
      });
      yield put({
        type: 'setGrayTest',
        payload: ['releaseBeforeAuditAbTest', response2],
      });
      // 同层实验
      if (_WEBSTATIC_GRAY_STRATEGY_ID.startsWith('gray-release-poi-samelevel')) {
        window.poisgcgray = _WEBSTATIC_GRAY_STRATEGY_ID;
      }
    },
    *fetchZdcPermissionCheck({ payload }, { call, put }) {
      const response = yield call(fetchZdcPermissionCheck, payload);
      if (response.code === 901) {
        yield put({
          type: 'permissionReject',
          payload: {
            code: response.code,
          },
        });
      }
    },
  },

  reducers: {
    lxPv(state, { payload }) {
      return produce(state, draft => {
        draft.currentCid = payload;
      });
    },
    lxGlobal(state, { payload }) {
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft.lxGlobalLab[key] = payload[key];
        });
      });
    },
    permissionReject(state, action) {
      const { payload = {} } = action;
      return {
        ...state,
        permissionCode: payload.code,
      };
    },
    save(state, action) {
      return {
        ...state,
        list: action.payload,
      };
    },
    setSameLevelTest(state, action) {
      const [testKey, data] = action.payload;

      return {
        ...state,
        [testKey]: data,
      };
    },
    setGrayTest(state, action) {
      if (window.location.search.includes('_ab_=1')) {
        return {
          ...state,
          abTest: true,
        };
      }
      const [testKey, data] = action.payload;

      if (data && data.hitStrategy) {
        return {
          ...state,
          [testKey]: true,
        };
      }
      return state;
    },
    saveCurrentUser(state, action) {
      if (action.payload) {
        LXAnalytics('set', 'uid', action.payload.id);
      }
      return {
        ...state,
        currentUser: action.payload || {},
      };
    },
    changeNotifyCount(state, action) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          notifyCount: action.payload,
        },
      };
    },
  },
};
